const REQUEST_WEATHERDAILY = state => {
  state.statusWeather = "fetching";
};

const SUCCESS_REQUEST_WEATHERDAILY = (state, { body }) => {
  state.WeatherDaily = body;
  state.statusWeather = "success";
};

const FAILURE_REQUEST_WEATHERDAILY = state => {
  state.statusWeather = "failure";
};

const REQUEST_PV_FORECAST = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_PV_FORECAST = (state, { body }) => {
  state.PVForecast = Array.isArray(body) ? body : [];
  state.status = "success";
};

const FAILURE_REQUEST_PV_FORECAST = state => {
  state.PVForecast = [];
  state.status = "failure";
};


export default {
  REQUEST_WEATHERDAILY,
  SUCCESS_REQUEST_WEATHERDAILY,
  FAILURE_REQUEST_WEATHERDAILY,
 
  REQUEST_PV_FORECAST,
  SUCCESS_REQUEST_PV_FORECAST,
  FAILURE_REQUEST_PV_FORECAST,
};
